// extracted by mini-css-extract-plugin
export default {"title":"styles_title__eFMjL","subtitle":"styles_subtitle__jwB4q","vid":"styles_vid__jDtaf","vidContainer":"styles_vidContainer__U0bB8"};